// Order Register toolbar registry — shared by the tab (Hide buttons menu)
// and the admin rights box (allowed buttons).
export const TB_TOOLS = [
  { group: "Actions", items: [
    { id: "or-add", label: "New Order" },
    { id: "or-upload", label: "Upload Excel" },
    { id: "or-export", label: "Export" },
    { id: "or-export-scope-btn", label: "Export by scope" },
    { id: "or-screen-print", label: "Screen print" },
    { id: "or-pending-btn", label: "Pending Center" },
    { id: "or-raw-api-btn", label: "API (raw / powder) filter" },
    { id: "or-uploads-btn", label: "Uploads" },
    { id: "or-overwrite-history-btn", label: "Overwrite history" },
    { id: "or-emirates-fill-btn", label: "Emirates tracking fill" },
    { id: "or-bulk-price-btn", label: "Update prices" },
  ]},
  { group: "Filters & presets", items: [
    { id: "or-mode-filter", label: "Mode filter" },
    { id: "or-date-from", label: "Date from" },
    { id: "or-date-to", label: "Date to" },
    { id: "or-owner-filter", label: "Owner filter" },
    { id: "or-search", label: "Search box" },
    { id: "or-preset-no-invoice", label: "Preset: no invoice" },
    { id: "or-preset-no-tracking", label: "Preset: no tracking" },
    { id: "or-preset-no-secondname", label: "Preset: no second name" },
    { id: "or-preset-no-price", label: "Preset: no price" },
    { id: "or-ageing-chip", label: "Ageing chip" },
    { id: "or-today-parcels-chip", label: "Today parcels chip" },
    { id: "or-teamview-toggle", label: "Team view toggle" },
    { id: "or-cols-btn", label: "Hide Columns" },
    { id: "or-refresh", label: "Refresh" },
  ]},
  { group: "Invoice cards", items: [
    { id: "or-invoice-cards", label: "Invoice stat cards",
      also: ["or-today-invoices-collapsed", "or-today-invoices-pending-badge-collapsed"] },
  ]},
  { group: "Admin tools", items: [
    { id: "or-audit-log-btn", label: "Audit log" },
    { id: "or-bulk-cancel", label: "Bulk cancel" },
    { id: "or-bulk-reason", label: "Bulk set reason" },
    { id: "or-bulk-delete", label: "Bulk delete" },
    { id: "or-delete-scope-btn", label: "Delete by scope" },
    { id: "or-recover", label: "Recover" },
    { id: "or-pricing-chip", label: "Pricing chip" },
    { id: "or-fill-aliases", label: "Fill aliases" },
    { id: "or-suggest-aliases", label: "Suggest aliases" },
  ]},
  { group: "Info bars", items: [
    { id: "or-color-legend", label: "Colour legend" },
    { id: "or-workload-row", label: "Open by owner bar" },
    { id: "or-multiparcel-banner", label: "Merge guardrail banner" },
  ]},
];

// Write tools always forced off for view-only users.
export const OR_WRITE_TOOLS = ['or-add', 'or-upload', 'or-emirates-fill-btn', 'or-bulk-price-btn',
  'or-bulk-cancel', 'or-bulk-reason', 'or-bulk-delete', 'or-delete-scope-btn', 'or-recover', 'or-fill-aliases',
  'or-suggest-aliases'];
